import script from "./TournamentInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./TournamentInfo.vue?vue&type=script&lang=ts&setup=true"

import "./TournamentInfo.vue?vue&type=style&index=0&id=310c7d40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-310c7d40"]])

export default __exports__